import { jsx as a, jsxs as D, Fragment as Ye } from "react/jsx-runtime";
import * as T from "react";
import et, { useState as q, createContext as ae, useMemo as J, useContext as tt, Component as pr, createElement as Le, useCallback as rt, useEffect as nt, StrictMode as mr } from "react";
import yr from "axios";
import { ThemeProvider as gr, useTheme as vr, useMediaQuery as br, Typography as U, IconButton as ie, Drawer as Cr, Snackbar as Sr, Alert as Or, MenuItem as Rr, ListItemIcon as wr, Divider as Er, Button as Pr, Menu as xr } from "@mui/material";
import _r from "@mui/material/Avatar";
import { useTranslation as Re, I18nextProvider as Mr } from "react-i18next";
import { createInstance as Ir } from "i18next";
import Dr from "i18next-browser-languagedetector";
import Tr from "i18next-chained-backend";
import Fr from "i18next-resources-to-backend";
import { createTheme as Lr } from "@mui/material/styles";
class X {
  constructor() {
    this.listeners = [], this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.push(e), this.onSubscribe(), () => {
      this.listeners = this.listeners.filter((r) => r !== e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.length > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const Z = typeof window > "u" || "Deno" in window;
function k() {
}
function kr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function be(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function it(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function $(t, e, r) {
  return ue(t) ? typeof e == "function" ? {
    ...r,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function B(t, e, r) {
  return ue(t) ? [{
    ...e,
    queryKey: t
  }, r] : [t || {}, e];
}
function ke(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: s,
    queryKey: o,
    stale: u
  } = t;
  if (ue(o)) {
    if (n) {
      if (e.queryHash !== we(o, e.options))
        return !1;
    } else if (!K(e.queryKey, o))
      return !1;
  }
  if (r !== "all") {
    const c = e.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || typeof i < "u" && i !== e.state.fetchStatus || s && !s(e));
}
function Ue(t, e) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: s
  } = t;
  if (ue(s)) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (V(e.options.mutationKey) !== V(s))
        return !1;
    } else if (!K(e.options.mutationKey, s))
      return !1;
  }
  return !(typeof n == "boolean" && e.state.status === "loading" !== n || i && !i(e));
}
function we(t, e) {
  return (e?.queryKeyHashFn || V)(t);
}
function V(t) {
  return JSON.stringify(t, (e, r) => Ce(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function K(t, e) {
  return st(t, e);
}
function st(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !st(t[r], e[r])) : !1;
}
function ot(t, e) {
  if (t === e)
    return t;
  const r = qe(t) && qe(e);
  if (r || Ce(t) && Ce(e)) {
    const n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), s = i.length, o = r ? [] : {};
    let u = 0;
    for (let c = 0; c < s; c++) {
      const h = r ? c : i[c];
      o[h] = ot(t[h], e[h]), o[h] === t[h] && u++;
    }
    return n === s && u === n ? t : o;
  }
  return e;
}
function Ae(t, e) {
  if (t && !e || e && !t)
    return !1;
  for (const r in t)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function qe(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Ce(t) {
  if (!Qe(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const r = e.prototype;
  return !(!Qe(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function Qe(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ue(t) {
  return Array.isArray(t);
}
function at(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Be(t) {
  at(0).then(t);
}
function Ur() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Se(t, e, r) {
  return r.isDataEqual != null && r.isDataEqual(t, e) ? t : typeof r.structuralSharing == "function" ? r.structuralSharing(t, e) : r.structuralSharing !== !1 ? ot(t, e) : e;
}
class Ar extends X {
  constructor() {
    super(), this.setup = (e) => {
      if (!Z && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach((e) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const se = new Ar();
class qr extends X {
  constructor() {
    super(), this.setup = (e) => {
      if (!Z && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach((e) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const oe = new qr();
function Qr(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function le(t) {
  return (t ?? "online") === "online" ? oe.isOnline() : !0;
}
class ut {
  constructor(e) {
    this.revert = e?.revert, this.silent = e?.silent;
  }
}
function ne(t) {
  return t instanceof ut;
}
function lt(t) {
  let e = !1, r = 0, n = !1, i, s, o;
  const u = new Promise((p, w) => {
    s = p, o = w;
  }), c = (p) => {
    n || (m(new ut(p)), t.abort == null || t.abort());
  }, h = () => {
    e = !0;
  }, d = () => {
    e = !1;
  }, f = () => !se.isFocused() || t.networkMode !== "always" && !oe.isOnline(), b = (p) => {
    n || (n = !0, t.onSuccess == null || t.onSuccess(p), i?.(), s(p));
  }, m = (p) => {
    n || (n = !0, t.onError == null || t.onError(p), i?.(), o(p));
  }, R = () => new Promise((p) => {
    i = (w) => {
      const M = n || !f();
      return M && p(w), M;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, n || t.onContinue == null || t.onContinue();
  }), O = () => {
    if (n)
      return;
    let p;
    try {
      p = t.fn();
    } catch (w) {
      p = Promise.reject(w);
    }
    Promise.resolve(p).then(b).catch((w) => {
      var M, g;
      if (n)
        return;
      const C = (M = t.retry) != null ? M : 3, _ = (g = t.retryDelay) != null ? g : Qr, v = typeof _ == "function" ? _(r, w) : _, S = C === !0 || typeof C == "number" && r < C || typeof C == "function" && C(r, w);
      if (e || !S) {
        m(w);
        return;
      }
      r++, t.onFail == null || t.onFail(r, w), at(v).then(() => {
        if (f())
          return R();
      }).then(() => {
        e ? m(w) : O();
      });
    });
  };
  return le(t.networkMode) ? O() : R().then(O), {
    promise: u,
    cancel: c,
    continue: () => i?.() ? u : Promise.resolve(),
    cancelRetry: h,
    continueRetry: d
  };
}
const Ee = console;
function Br() {
  let t = [], e = 0, r = (d) => {
    d();
  }, n = (d) => {
    d();
  };
  const i = (d) => {
    let f;
    e++;
    try {
      f = d();
    } finally {
      e--, e || u();
    }
    return f;
  }, s = (d) => {
    e ? t.push(d) : Be(() => {
      r(d);
    });
  }, o = (d) => (...f) => {
    s(() => {
      d(...f);
    });
  }, u = () => {
    const d = t;
    t = [], d.length && Be(() => {
      n(() => {
        d.forEach((f) => {
          r(f);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: o,
    schedule: s,
    setNotifyFunction: (d) => {
      r = d;
    },
    setBatchNotifyFunction: (d) => {
      n = d;
    }
  };
}
const I = Br();
class ct {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), be(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (Z ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class jr extends ct {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || Ee, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || Hr(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, r) {
    const n = Se(this.state.data, e, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r?.updatedAt,
      manual: r?.manual
    }), n;
  }
  setState(e, r) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: r
    });
  }
  cancel(e) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(e), n ? n.then(k).catch(k) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !it(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var s;
        return (s = this.retryer) == null || s.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const m = this.observers.find((R) => R.options.queryFn);
      m && this.setOptions(m.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const o = Ur(), u = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (m) => {
      Object.defineProperty(m, "signal", {
        enumerable: !0,
        get: () => {
          if (o)
            return this.abortSignalConsumed = !0, o.signal;
        }
      });
    };
    c(u);
    const h = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(u)) : Promise.reject("Missing queryFn"), d = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: h
    };
    if (c(d), (n = this.options.behavior) == null || n.onFetch(d), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = d.fetchOptions) == null ? void 0 : i.meta)) {
      var f;
      this.dispatch({
        type: "fetch",
        meta: (f = d.fetchOptions) == null ? void 0 : f.meta
      });
    }
    const b = (m) => {
      if (ne(m) && m.silent || this.dispatch({
        type: "error",
        error: m
      }), !ne(m)) {
        var R, O, p, w;
        (R = (O = this.cache.config).onError) == null || R.call(O, m, this), (p = (w = this.cache.config).onSettled) == null || p.call(w, this.state.data, m, this), process.env.NODE_ENV !== "production" && this.logger.error(m);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = lt({
      fn: d.fetchFn,
      abort: o?.abort.bind(o),
      onSuccess: (m) => {
        var R, O, p, w;
        if (typeof m > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), b(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(m), (R = (O = this.cache.config).onSuccess) == null || R.call(O, m, this), (p = (w = this.cache.config).onSettled) == null || p.call(w, m, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: b,
      onFail: (m, R) => {
        this.dispatch({
          type: "failed",
          failureCount: m,
          error: R
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: d.options.retry,
      retryDelay: d.options.retryDelay,
      networkMode: d.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const r = (n) => {
      var i, s;
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: le(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: e.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (s = e.dataUpdatedAt) != null ? s : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const o = e.error;
          return ne(o) && o.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: o,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: o,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), I.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function Hr(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class Nr extends X {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, r, n) {
    var i;
    const s = r.queryKey, o = (i = r.queryHash) != null ? i : we(s, r);
    let u = this.get(o);
    return u || (u = new jr({
      cache: this,
      logger: e.getLogger(),
      queryKey: s,
      queryHash: o,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(s)
    }), this.add(u)), u;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.queriesMap[e.queryHash];
    r && (e.destroy(), this.queries = this.queries.filter((n) => n !== e), r === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    I.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, r) {
    const [n] = B(e, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => ke(n, i));
  }
  findAll(e, r) {
    const [n] = B(e, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => ke(n, i)) : this.queries;
  }
  notify(e) {
    I.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  onFocus() {
    I.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    I.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class Vr extends ct {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || Ee, this.observers = [], this.state = e.state || zr(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((r) => r !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, r;
    return (e = (r = this.retryer) == null ? void 0 : r.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var S;
      return this.retryer = lt({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (y, E) => {
          this.dispatch({
            type: "failed",
            failureCount: y,
            error: E
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (S = this.options.retry) != null ? S : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, s, o, u, c, h, d;
      if (!r) {
        var f, b, m, R;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((f = (b = this.mutationCache.config).onMutate) == null ? void 0 : f.call(b, this.state.variables, this));
        const y = await ((m = (R = this.options).onMutate) == null ? void 0 : m.call(R, this.state.variables));
        y !== this.state.context && this.dispatch({
          type: "loading",
          context: y,
          variables: this.state.variables
        });
      }
      const S = await e();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, S, this.state.variables, this.state.context, this)), await ((s = (o = this.options).onSuccess) == null ? void 0 : s.call(o, S, this.state.variables, this.state.context)), await ((u = (c = this.mutationCache.config).onSettled) == null ? void 0 : u.call(c, S, null, this.state.variables, this.state.context, this)), await ((h = (d = this.options).onSettled) == null ? void 0 : h.call(d, S, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: S
      }), S;
    } catch (S) {
      try {
        var O, p, w, M, g, C, _, v;
        throw await ((O = (p = this.mutationCache.config).onError) == null ? void 0 : O.call(p, S, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(S), await ((w = (M = this.options).onError) == null ? void 0 : w.call(M, S, this.state.variables, this.state.context)), await ((g = (C = this.mutationCache.config).onSettled) == null ? void 0 : g.call(C, void 0, S, this.state.variables, this.state.context, this)), await ((_ = (v = this.options).onSettled) == null ? void 0 : _.call(v, void 0, S, this.state.variables, this.state.context)), S;
      } finally {
        this.dispatch({
          type: "error",
          error: S
        });
      }
    }
  }
  dispatch(e) {
    const r = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !le(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), I.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function zr() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class Kr extends X {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, r, n) {
    const i = new Vr({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? e.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((r) => r !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    I.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((r) => Ue(e, r));
  }
  findAll(e) {
    return this.mutations.filter((r) => Ue(e, r));
  }
  notify(e) {
    I.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return I.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(k)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function Wr() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, r, n, i, s, o;
        const u = (e = t.fetchOptions) == null || (r = e.meta) == null ? void 0 : r.refetchPage, c = (n = t.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, h = c?.pageParam, d = c?.direction === "forward", f = c?.direction === "backward", b = ((s = t.state.data) == null ? void 0 : s.pages) || [], m = ((o = t.state.data) == null ? void 0 : o.pageParams) || [];
        let R = m, O = !1;
        const p = (v) => {
          Object.defineProperty(v, "signal", {
            enumerable: !0,
            get: () => {
              var S;
              if ((S = t.signal) != null && S.aborted)
                O = !0;
              else {
                var y;
                (y = t.signal) == null || y.addEventListener("abort", () => {
                  O = !0;
                });
              }
              return t.signal;
            }
          });
        }, w = t.options.queryFn || (() => Promise.reject("Missing queryFn")), M = (v, S, y, E) => (R = E ? [S, ...R] : [...R, S], E ? [y, ...v] : [...v, y]), g = (v, S, y, E) => {
          if (O)
            return Promise.reject("Cancelled");
          if (typeof y > "u" && !S && v.length)
            return Promise.resolve(v);
          const F = {
            queryKey: t.queryKey,
            pageParam: y,
            meta: t.options.meta
          };
          p(F);
          const Q = w(F);
          return Promise.resolve(Q).then((z) => M(v, y, z, E));
        };
        let C;
        if (!b.length)
          C = g([]);
        else if (d) {
          const v = typeof h < "u", S = v ? h : je(t.options, b);
          C = g(b, v, S);
        } else if (f) {
          const v = typeof h < "u", S = v ? h : $r(t.options, b);
          C = g(b, v, S, !0);
        } else {
          R = [];
          const v = typeof t.options.getNextPageParam > "u";
          C = (u && b[0] ? u(b[0], 0, b) : !0) ? g([], v, m[0]) : Promise.resolve(M([], m[0], b[0]));
          for (let y = 1; y < b.length; y++)
            C = C.then((E) => {
              if (u && b[y] ? u(b[y], y, b) : !0) {
                const Q = v ? m[y] : je(t.options, E);
                return g(E, v, Q);
              }
              return Promise.resolve(M(E, m[y], b[y]));
            });
        }
        return C.then((v) => ({
          pages: v,
          pageParams: R
        }));
      };
    }
  };
}
function je(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function $r(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class Gr {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new Nr(), this.mutationCache = e.mutationCache || new Kr(), this.logger = e.logger || Ee, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = se.subscribe(() => {
      se.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = oe.subscribe(() => {
      oe.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, r;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, r) {
    const [n] = B(e, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e, r, n) {
    const i = $(e, r, n), s = this.getQueryData(i.queryKey);
    return s ? Promise.resolve(s) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const i = this.queryCache.find(e), s = i?.state.data, o = kr(r, s);
    if (typeof o > "u")
      return;
    const u = $(e), c = this.defaultQueryOptions(u);
    return this.queryCache.build(this, c).setData(o, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(e, r, n) {
    return I.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state;
  }
  removeQueries(e, r) {
    const [n] = B(e, r), i = this.queryCache;
    I.batch(() => {
      i.findAll(n).forEach((s) => {
        i.remove(s);
      });
    });
  }
  resetQueries(e, r, n) {
    const [i, s] = B(e, r, n), o = this.queryCache, u = {
      type: "active",
      ...i
    };
    return I.batch(() => (o.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(u, s)));
  }
  cancelQueries(e, r, n) {
    const [i, s = {}] = B(e, r, n);
    typeof s.revert > "u" && (s.revert = !0);
    const o = I.batch(() => this.queryCache.findAll(i).map((u) => u.cancel(s)));
    return Promise.all(o).then(k).catch(k);
  }
  invalidateQueries(e, r, n) {
    const [i, s] = B(e, r, n);
    return I.batch(() => {
      var o, u;
      if (this.queryCache.findAll(i).forEach((h) => {
        h.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (o = (u = i.refetchType) != null ? u : i.type) != null ? o : "active"
      };
      return this.refetchQueries(c, s);
    });
  }
  refetchQueries(e, r, n) {
    const [i, s] = B(e, r, n), o = I.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var h;
      return c.fetch(void 0, {
        ...s,
        cancelRefetch: (h = s?.cancelRefetch) != null ? h : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let u = Promise.all(o).then(k);
    return s != null && s.throwOnError || (u = u.catch(k)), u;
  }
  fetchQuery(e, r, n) {
    const i = $(e, r, n), s = this.defaultQueryOptions(i);
    typeof s.retry > "u" && (s.retry = !1);
    const o = this.queryCache.build(this, s);
    return o.isStaleByTime(s.staleTime) ? o.fetch(s) : Promise.resolve(o.state.data);
  }
  prefetchQuery(e, r, n) {
    return this.fetchQuery(e, r, n).then(k).catch(k);
  }
  fetchInfiniteQuery(e, r, n) {
    const i = $(e, r, n);
    return i.behavior = Wr(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, r, n) {
    return this.fetchInfiniteQuery(e, r, n).then(k).catch(k);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, r) {
    const n = this.queryDefaults.find((i) => V(e) === V(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const r = this.queryDefaults.find((n) => K(e, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((i) => K(e, i.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r?.defaultOptions;
  }
  setMutationDefaults(e, r) {
    const n = this.mutationDefaults.find((i) => V(e) === V(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const r = this.mutationDefaults.find((n) => K(e, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((i) => K(e, i.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r?.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e?.queryKey),
      ...e,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = we(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e?.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class Zr extends X {
  constructor(e, r) {
    super(), this.client = e, this.options = r, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.length === 1 && (this.currentQuery.addObserver(this), He(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.listeners.length || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Oe(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return Oe(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = [], this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(e, r) {
    const n = this.options, i = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(e), process.env.NODE_ENV !== "production" && typeof e?.isDataEqual < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), Ae(n, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = n.queryKey), this.updateQuery();
    const s = this.hasListeners();
    s && Ne(this.currentQuery, i, this.options, n) && this.executeFetch(), this.updateResult(r), s && (this.currentQuery !== i || this.options.enabled !== n.enabled || this.options.staleTime !== n.staleTime) && this.updateStaleTimeout();
    const o = this.computeRefetchInterval();
    s && (this.currentQuery !== i || this.options.enabled !== n.enabled || o !== this.currentRefetchInterval) && this.updateRefetchInterval(o);
  }
  getOptimisticResult(e) {
    const r = this.client.getQueryCache().build(this.client, e);
    return this.createResult(r, e);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(e) {
    const r = {};
    return Object.keys(e).forEach((n) => {
      Object.defineProperty(r, n, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(n), e[n])
      });
    }), r;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: e,
    ...r
  } = {}) {
    return this.fetch({
      ...r,
      meta: {
        refetchPage: e
      }
    });
  }
  fetchOptimistic(e) {
    const r = this.client.defaultQueryOptions(e), n = this.client.getQueryCache().build(this.client, r);
    return n.isFetchingOptimistic = !0, n.fetch().then(() => this.createResult(n, r));
  }
  fetch(e) {
    var r;
    return this.executeFetch({
      ...e,
      cancelRefetch: (r = e.cancelRefetch) != null ? r : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(e) {
    this.updateQuery();
    let r = this.currentQuery.fetch(this.options, e);
    return e != null && e.throwOnError || (r = r.catch(k)), r;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), Z || this.currentResult.isStale || !be(this.options.staleTime))
      return;
    const r = it(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, r);
  }
  computeRefetchInterval() {
    var e;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
  }
  updateRefetchInterval(e) {
    this.clearRefetchInterval(), this.currentRefetchInterval = e, !(Z || this.options.enabled === !1 || !be(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || se.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(e, r) {
    const n = this.currentQuery, i = this.options, s = this.currentResult, o = this.currentResultState, u = this.currentResultOptions, c = e !== n, h = c ? e.state : this.currentQueryInitialState, d = c ? this.currentResult : this.previousQueryResult, {
      state: f
    } = e;
    let {
      dataUpdatedAt: b,
      error: m,
      errorUpdatedAt: R,
      fetchStatus: O,
      status: p
    } = f, w = !1, M = !1, g;
    if (r._optimisticResults) {
      const y = this.hasListeners(), E = !y && He(e, r), F = y && Ne(e, n, r, i);
      (E || F) && (O = le(e.options.networkMode) ? "fetching" : "paused", b || (p = "loading")), r._optimisticResults === "isRestoring" && (O = "idle");
    }
    if (r.keepPreviousData && !f.dataUpdatedAt && d != null && d.isSuccess && p !== "error")
      g = d.data, b = d.dataUpdatedAt, p = d.status, w = !0;
    else if (r.select && typeof f.data < "u")
      if (s && f.data === o?.data && r.select === this.selectFn)
        g = this.selectResult;
      else
        try {
          this.selectFn = r.select, g = r.select(f.data), g = Se(s?.data, g, r), this.selectResult = g, this.selectError = null;
        } catch (y) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(y), this.selectError = y;
        }
    else
      g = f.data;
    if (typeof r.placeholderData < "u" && typeof g > "u" && p === "loading") {
      let y;
      if (s != null && s.isPlaceholderData && r.placeholderData === u?.placeholderData)
        y = s.data;
      else if (y = typeof r.placeholderData == "function" ? r.placeholderData() : r.placeholderData, r.select && typeof y < "u")
        try {
          y = r.select(y), this.selectError = null;
        } catch (E) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(E), this.selectError = E;
        }
      typeof y < "u" && (p = "success", g = Se(s?.data, y, r), M = !0);
    }
    this.selectError && (m = this.selectError, g = this.selectResult, R = Date.now(), p = "error");
    const C = O === "fetching", _ = p === "loading", v = p === "error";
    return {
      status: p,
      fetchStatus: O,
      isLoading: _,
      isSuccess: p === "success",
      isError: v,
      isInitialLoading: _ && C,
      data: g,
      dataUpdatedAt: b,
      error: m,
      errorUpdatedAt: R,
      failureCount: f.fetchFailureCount,
      failureReason: f.fetchFailureReason,
      errorUpdateCount: f.errorUpdateCount,
      isFetched: f.dataUpdateCount > 0 || f.errorUpdateCount > 0,
      isFetchedAfterMount: f.dataUpdateCount > h.dataUpdateCount || f.errorUpdateCount > h.errorUpdateCount,
      isFetching: C,
      isRefetching: C && !_,
      isLoadingError: v && f.dataUpdatedAt === 0,
      isPaused: O === "paused",
      isPlaceholderData: M,
      isPreviousData: w,
      isRefetchError: v && f.dataUpdatedAt !== 0,
      isStale: Pe(e, r),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(e) {
    const r = this.currentResult, n = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, Ae(n, r))
      return;
    this.currentResult = n;
    const i = {
      cache: !0
    }, s = () => {
      if (!r)
        return !0;
      const {
        notifyOnChangeProps: o
      } = this.options;
      if (o === "all" || !o && !this.trackedProps.size)
        return !0;
      const u = new Set(o ?? this.trackedProps);
      return this.options.useErrorBoundary && u.add("error"), Object.keys(this.currentResult).some((c) => {
        const h = c;
        return this.currentResult[h] !== r[h] && u.has(h);
      });
    };
    e?.listeners !== !1 && s() && (i.listeners = !0), this.notify({
      ...i,
      ...e
    });
  }
  updateQuery() {
    const e = this.client.getQueryCache().build(this.client, this.options);
    if (e === this.currentQuery)
      return;
    const r = this.currentQuery;
    this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (r?.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate(e) {
    const r = {};
    e.type === "success" ? r.onSuccess = !e.manual : e.type === "error" && !ne(e.error) && (r.onError = !0), this.updateResult(r), this.hasListeners() && this.updateTimers();
  }
  notify(e) {
    I.batch(() => {
      if (e.onSuccess) {
        var r, n, i, s;
        (r = (n = this.options).onSuccess) == null || r.call(n, this.currentResult.data), (i = (s = this.options).onSettled) == null || i.call(s, this.currentResult.data, null);
      } else if (e.onError) {
        var o, u, c, h;
        (o = (u = this.options).onError) == null || o.call(u, this.currentResult.error), (c = (h = this.options).onSettled) == null || c.call(h, void 0, this.currentResult.error);
      }
      e.listeners && this.listeners.forEach((d) => {
        d(this.currentResult);
      }), e.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function Jr(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}
function He(t, e) {
  return Jr(t, e) || t.state.dataUpdatedAt > 0 && Oe(t, e, e.refetchOnMount);
}
function Oe(t, e, r) {
  if (e.enabled !== !1) {
    const n = typeof r == "function" ? r(t) : r;
    return n === "always" || n !== !1 && Pe(t, e);
  }
  return !1;
}
function Ne(t, e, r, n) {
  return r.enabled !== !1 && (t !== e || n.enabled === !1) && (!r.suspense || t.state.status !== "error") && Pe(t, r);
}
function Pe(t, e) {
  return t.isStaleByTime(e.staleTime);
}
var ee = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var te = { exports: {} }, me = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ve;
function Yr() {
  if (Ve) return me;
  Ve = 1;
  var t = et;
  function e(f, b) {
    return f === b && (f !== 0 || 1 / f === 1 / b) || f !== f && b !== b;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, s = t.useLayoutEffect, o = t.useDebugValue;
  function u(f, b) {
    var m = b(), R = n({ inst: { value: m, getSnapshot: b } }), O = R[0].inst, p = R[1];
    return s(function() {
      O.value = m, O.getSnapshot = b, c(O) && p({ inst: O });
    }, [f, m, b]), i(function() {
      return c(O) && p({ inst: O }), f(function() {
        c(O) && p({ inst: O });
      });
    }, [f]), o(m), m;
  }
  function c(f) {
    var b = f.getSnapshot;
    f = f.value;
    try {
      var m = b();
      return !r(f, m);
    } catch {
      return !0;
    }
  }
  function h(f, b) {
    return b();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? h : u;
  return me.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, me;
}
var ye = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ze;
function en() {
  return ze || (ze = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = et, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(g) {
      {
        for (var C = arguments.length, _ = new Array(C > 1 ? C - 1 : 0), v = 1; v < C; v++)
          _[v - 1] = arguments[v];
        n("error", g, _);
      }
    }
    function n(g, C, _) {
      {
        var v = e.ReactDebugCurrentFrame, S = v.getStackAddendum();
        S !== "" && (C += "%s", _ = _.concat([S]));
        var y = _.map(function(E) {
          return String(E);
        });
        y.unshift("Warning: " + C), Function.prototype.apply.call(console[g], console, y);
      }
    }
    function i(g, C) {
      return g === C && (g !== 0 || 1 / g === 1 / C) || g !== g && C !== C;
    }
    var s = typeof Object.is == "function" ? Object.is : i, o = t.useState, u = t.useEffect, c = t.useLayoutEffect, h = t.useDebugValue, d = !1, f = !1;
    function b(g, C, _) {
      d || t.startTransition !== void 0 && (d = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var v = C();
      if (!f) {
        var S = C();
        s(v, S) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var y = o({
        inst: {
          value: v,
          getSnapshot: C
        }
      }), E = y[0].inst, F = y[1];
      return c(function() {
        E.value = v, E.getSnapshot = C, m(E) && F({
          inst: E
        });
      }, [g, v, C]), u(function() {
        m(E) && F({
          inst: E
        });
        var Q = function() {
          m(E) && F({
            inst: E
          });
        };
        return g(Q);
      }, [g]), h(v), v;
    }
    function m(g) {
      var C = g.getSnapshot, _ = g.value;
      try {
        var v = C();
        return !s(_, v);
      } catch {
        return !0;
      }
    }
    function R(g, C, _) {
      return C();
    }
    var O = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", p = !O, w = p ? R : b, M = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : w;
    ye.useSyncExternalStore = M, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ye;
}
var Ke;
function tn() {
  return Ke || (Ke = 1, process.env.NODE_ENV === "production" ? te.exports = Yr() : te.exports = en()), te.exports;
}
var rn = tn();
const nn = rn.useSyncExternalStore, We = /* @__PURE__ */ T.createContext(void 0), dt = /* @__PURE__ */ T.createContext(!1);
function ht(t, e) {
  return t || (e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = We), window.ReactQueryClientContext) : We);
}
const sn = ({
  context: t
} = {}) => {
  const e = T.useContext(ht(t, T.useContext(dt)));
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, on = ({
  client: t,
  children: e,
  context: r,
  contextSharing: n = !1
}) => {
  T.useEffect(() => (t.mount(), () => {
    t.unmount();
  }), [t]), process.env.NODE_ENV !== "production" && n && t.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const i = ht(r, n);
  return /* @__PURE__ */ T.createElement(dt.Provider, {
    value: !r && n
  }, /* @__PURE__ */ T.createElement(i.Provider, {
    value: t
  }, e));
}, ft = /* @__PURE__ */ T.createContext(!1), an = () => T.useContext(ft);
ft.Provider;
function un() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
const ln = /* @__PURE__ */ T.createContext(un()), cn = () => T.useContext(ln);
function dn(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
const hn = (t, e) => {
  (t.suspense || t.useErrorBoundary) && (e.isReset() || (t.retryOnMount = !1));
}, fn = (t) => {
  T.useEffect(() => {
    t.clearReset();
  }, [t]);
}, pn = ({
  result: t,
  errorResetBoundary: e,
  useErrorBoundary: r,
  query: n
}) => t.isError && !e.isReset() && !t.isFetching && dn(r, [t.error, n]), mn = (t) => {
  t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
}, yn = (t, e) => t.isLoading && t.isFetching && !e, gn = (t, e, r) => t?.suspense && yn(e, r), vn = (t, e, r) => e.fetchOptimistic(t).then(({
  data: n
}) => {
  t.onSuccess == null || t.onSuccess(n), t.onSettled == null || t.onSettled(n, null);
}).catch((n) => {
  r.clearReset(), t.onError == null || t.onError(n), t.onSettled == null || t.onSettled(void 0, n);
});
function bn(t, e) {
  const r = sn({
    context: t.context
  }), n = an(), i = cn(), s = r.defaultQueryOptions(t);
  s._optimisticResults = n ? "isRestoring" : "optimistic", s.onError && (s.onError = I.batchCalls(s.onError)), s.onSuccess && (s.onSuccess = I.batchCalls(s.onSuccess)), s.onSettled && (s.onSettled = I.batchCalls(s.onSettled)), mn(s), hn(s, i), fn(i);
  const [o] = T.useState(() => new e(r, s)), u = o.getOptimisticResult(s);
  if (nn(T.useCallback((c) => n ? () => {
  } : o.subscribe(I.batchCalls(c)), [o, n]), () => o.getCurrentResult(), () => o.getCurrentResult()), T.useEffect(() => {
    o.setOptions(s, {
      listeners: !1
    });
  }, [s, o]), gn(s, u, n))
    throw vn(s, o, i);
  if (pn({
    result: u,
    errorResetBoundary: i,
    useErrorBoundary: s.useErrorBoundary,
    query: o.getCurrentQuery()
  }))
    throw u.error;
  return s.notifyOnChangeProps ? u : o.trackResult(u);
}
function Cn(t, e, r) {
  const n = $(t, e, r);
  return bn(n, Zr);
}
const P = {
  common: {
    black: "#27272C",
    white: "#ffffff"
  },
  primary: {
    main: "#4D4E58",
    dark: "#1A1A1A"
  },
  secondary: {
    main: "#f5f5f7",
    contrastText: "#86868b"
  },
  text: {
    primary: "#4D4E58",
    secondary: "#707075",
    disabled: "#86868b"
  },
  grey: {
    300: "#e4e4e4",
    500: "#333333"
  },
  success: {
    main: "#7dc64e"
  },
  error: {
    main: "#ED6DB8"
  },
  warning: {
    main: "#F8B263"
  },
  background: {
    default: "#ffffff",
    paper: "#ffffff",
    surfaceLightGray: "#F5F5F7"
  },
  action: {
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "#C2C2C5",
    disabled: "rgba(0, 0, 0, 0.4)"
  }
}, Sn = {
  styleOverrides: {
    root: {
      marginRight: 0
    },
    label: {
      marginLeft: "12px"
    }
  }
}, On = {
  defaultProps: {
    disableRipple: !0,
    disableTouchRipple: !0,
    disableFocusRipple: !0,
    disableElevation: !0
  },
  styleOverrides: {
    root: {
      textTransform: "none",
      fontWeight: 400,
      whiteSpace: "nowrap",
      minWidth: "2em",
      borderRadius: "24px",
      ":focus": {
        outline: "none"
      },
      "&.underlined": {
        textDecoration: "underline",
        fontWeight: "normal"
      },
      "&.dense": {
        padding: 0
      },
      "&:disabled": {
        backgroundColor: P.grey[300],
        color: P.secondary.contrastText
      }
    },
    containedPrimary: {
      color: P.common.white,
      backgroundColor: P.primary.main,
      "&:hover": {
        backgroundColor: P.common.black
      }
    },
    textSecondary: {
      backgroundColor: "none",
      color: P.primary.main
    },
    containedSecondary: {
      color: P.primary.main,
      "&:hover": {
        backgroundColor: P.grey[300]
      }
    },
    textSizeSmall: {
      fontSize: "12px",
      lineHeight: "20px"
    },
    sizeSmall: {
      padding: "4px 12px",
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: 400
    },
    sizeMedium: {
      padding: "6px 16px",
      fontSize: "16px",
      lineHeight: "22px"
    },
    sizeLarge: {
      padding: "12px 24px",
      fontSize: "16px",
      lineHeight: "24px"
    },
    startIcon: {
      fontSize: "75% !important",
      marginRight: "0"
    },
    endIcon: {
      fontSize: "75% !important"
    }
  }
}, Rn = {
  defaultProps: {
    disableRipple: !0
  },
  styleOverrides: {
    root: {
      ":hover": {
        backgroundColor: P.secondary.main
      },
      "&.Mui-selected": {
        backgroundColor: P.secondary.main,
        "&:hover": {
          backgroundColor: P.secondary.main
        }
      },
      ".MuiListItemIcon-root ": {
        minWidth: "40px"
      }
    }
  }
}, wn = {
  defaultProps: {
    disableRipple: !0
  },
  styleOverrides: {
    root: {
      padding: "6px",
      "&.MuiIconButton-colorSuccess": {
        backgroundColor: P.success.main,
        color: P.common.white
      },
      "&.MuiIconButton-colorError": {
        backgroundColor: P.error.main,
        color: P.common.white
      },
      sizeSmall: {
        fontSize: "10px"
      },
      sizeMedium: {
        fontSize: "14px"
      },
      sizeLarge: {
        fontSize: "16px"
      }
    },
    colorSecondary: {
      color: P.text.primary,
      backgroundColor: P.secondary.main,
      "&:focus, &:active, &:hover": {
        backgroundColor: P.grey[300]
      }
    },
    colorPrimary: {
      backgroundColor: P.primary.main,
      color: P.common.white,
      "&:hover": {
        backgroundColor: P.common.black
      },
      "&:focus": {
        backgroundColor: P.primary.dark
      }
    }
  }
}, En = {
  defaultProps: {
    InputProps: {
      disableUnderline: !0
    }
  },
  styleOverrides: {
    root: {
      "input, textarea": {
        "&:focus": {
          boxShadow: "initial"
          // This fixes tailwind ring coloring
        }
      },
      "& .MuiInputBase-root": {
        borderRadius: "24px",
        "& .MuiInputBase-input": {
          height: "3rem",
          paddingTop: 0,
          paddingBottom: 0
        },
        "&.MuiInputBase-sizeSmall": {
          height: "2.25rem"
        }
      },
      "& .MuiFilledInput-root": {
        backgroundColor: P.secondary.main,
        "&:before, &:after": {
          borderBottom: "none"
        },
        "&:hover:before": {
          borderBottom: "none"
        }
      }
    }
  }
}, Pn = {
  defaultProps: {
    disableRipple: !0,
    disableTouchRipple: !0
  },
  styleOverrides: {
    root: {
      "&.MuiChip-colorDefault": {
        backgroundColor: P.secondary.main
      },
      ":active": {
        boxShadow: "none"
      },
      "&:hover": {
        backgroundColor: P.grey[300]
      },
      "&.MuiChip-outlinedSecondary": {
        color: P.text.primary,
        border: "none"
      }
    }
  }
}, xn = {
  styleOverrides: {
    paper: {
      borderRadius: "20px",
      boxShadow: "0px 10px 40px 0px rgba(0, 0, 0, 0.08)"
    }
  },
  defaultProps: {
    fullWidth: !0
  }
}, _n = {
  defaultProps: {
    disableUnderline: !1
  },
  styleOverrides: {
    select: {
      ".MuiSelect-select.MuiInput-input": {
        height: "auto",
        paddingTop: "0.5rem",
        paddingBottom: "0.5rem"
      }
    }
  }
}, Mn = {
  defaultProps: {
    disableUnderline: !0
  }
}, In = {
  styleOverrides: {
    root: {
      borderRadius: "8px"
    }
  }
}, Dn = {
  styleOverrides: {
    root: {
      "& .MuiBadge-badge": {
        color: P.common.white
      }
    }
  }
}, Tn = {
  styleOverrides: {
    root: {}
  }
}, Fn = {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center"
    }
  }
}, Ln = {
  defaultProps: {
    // @ts-ignore-next-line
    disableRipple: !0
  },
  styleOverrides: {
    root: {
      "&.Mui-selected": {
        color: P.primary.main
      },
      "&.Mui-selected:hover": {
        backgroundColor: P.grey[300]
      }
    },
    ellipsis: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    sizeLarge: {
      fontSize: "16px",
      width: "48px",
      height: "48px",
      margin: 0,
      borderRadius: "24px"
    }
  }
}, kn = {
  styleOverrides: {
    ul: {
      gap: "4px"
    }
  }
}, Un = Lr({
  breakpoints: {
    values: {
      xs: 480,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280
    }
  },
  typography: {
    fontFamily: "var(--font-main)",
    title1: { fontSize: "60px", lineHeight: "60px", fontWeight: 600 },
    title2: { fontSize: "36px", lineHeight: "48px", fontWeight: 600 },
    title3: { fontSize: "28px", lineHeight: "36px", fontWeight: 600 },
    title5: { fontSize: "13px", lineHeight: "20px", fontWeight: 600 },
    h1: { fontSize: "24px", lineHeight: "32px", fontWeight: 600 },
    h2: { fontSize: "20px", lineHeight: "32px", fontWeight: 600 },
    h3: { fontSize: "16px", lineHeight: "24px", fontWeight: 600 },
    body1: { fontSize: "16px", lineHeight: "24px", fontWeight: 400 },
    caption: { fontSize: "13px", lineHeight: "20px", fontWeight: 400 },
    caption2: { fontSize: "12px", lineHeight: "16px", fontWeight: 400 },
    caption2Caps: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: 600,
      textTransform: "uppercase"
    },
    caption3: { fontSize: "10px", lineHeight: "12px" }
  },
  palette: P,
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        * {
            font-family: 'Graphik';
        }
      `
    },
    MuiButton: On,
    MuiListItemButton: Rn,
    MuiIconButton: wn,
    MuiTextField: En,
    MuiSelect: _n,
    MuiChip: Pn,
    MuiDialog: xn,
    MuiInputBase: Mn,
    MuiListItem: In,
    MuiBadge: Dn,
    MuiMenuItem: Tn,
    MuiTypography: Fn,
    MuiFormControlLabel: Sn,
    MuiPaginationItem: Ln,
    MuiPagination: kn
  }
});
function An({
  children: t,
  theme: e = Un
}) {
  return /* @__PURE__ */ a(gr, { theme: e, children: t });
}
const qn = () => {
  const t = vr();
  return {
    isMobile: br(t.breakpoints.down("md"))
  };
}, Qn = ({
  string: t,
  saturation: e = 30,
  lightness: r = 80
}) => `hsl(${t.split("").reduce(
  (i, s) => +s.charCodeAt(0) + (i << 5) - i,
  0
) % 360}, ${e}%, ${r}%)`;
function pt({ children: t, sx: e, ...r }) {
  return /* @__PURE__ */ a(
    _r,
    {
      sx: {
        backgroundColor: Qn({
          string: t?.toString() ?? ""
        }),
        ...e
      },
      ...r,
      children: /* @__PURE__ */ a(U, { variant: "caption", color: "primary", fontWeight: "bold", children: t })
    }
  );
}
function Bn() {
  const [t, e] = q(null), r = !!t;
  function n(s) {
    e(s.currentTarget);
  }
  function i() {
    e(null);
  }
  return {
    open: r,
    anchorEl: t,
    onOpen: n,
    onClose: i
  };
}
function jn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "32/Arrow Circle", children: /* @__PURE__ */ a(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3784 7.91813C17.6811 7.58051 15.9218 7.75379 14.3229 8.41606C12.7241 9.07832 11.3575 10.1998 10.3961 11.6388C9.5019 12.977 8.99546 14.5338 8.92894 16.1373L10.6956 14.6167C11.0095 14.3465 11.4831 14.382 11.7533 14.6959C12.0235 15.0099 11.988 15.4834 11.6741 15.7536L8.61888 18.3832C8.30494 18.6534 7.8314 18.618 7.56119 18.304L4.93157 15.2488C4.66136 14.9349 4.69681 14.4613 5.01075 14.1911C5.32469 13.9209 5.79824 13.9564 6.06845 14.2703L7.4411 15.8651C7.55304 14.0611 8.14048 12.3146 9.14886 10.8054C10.2751 9.11981 11.876 7.80604 13.7489 7.03024C15.6218 6.25444 17.6828 6.05146 19.6711 6.44696C21.6594 6.84245 23.4858 7.81867 24.9192 9.25216C26.3527 10.6856 27.329 12.512 27.7245 14.5003C28.12 16.4886 27.917 18.5496 27.1412 20.4225C26.3654 22.2954 25.0516 23.8963 23.366 25.0226C21.6804 26.1488 19.6987 26.75 17.6714 26.75C17.2572 26.75 16.9214 26.4142 16.9214 26C16.9214 25.5858 17.2572 25.25 17.6714 25.25C19.402 25.25 21.0937 24.7368 22.5327 23.7754C23.9716 22.8139 25.0931 21.4473 25.7553 19.8485C26.4176 18.2496 26.5909 16.4903 26.2533 14.793C25.9157 13.0956 25.0823 11.5365 23.8586 10.3128C22.6349 9.08911 21.0758 8.25575 19.3784 7.91813Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Hn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "24/Arrow Left", children: /* @__PURE__ */ a(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.19194 7.05806C9.43602 7.30214 9.43602 7.69786 9.19194 7.94194L5.50888 11.625H19.8333C20.1785 11.625 20.4583 11.9048 20.4583 12.25C20.4583 12.5952 20.1785 12.875 19.8333 12.875H5.50888L9.19194 16.5581C9.43602 16.8021 9.43602 17.1979 9.19194 17.4419C8.94786 17.686 8.55214 17.686 8.30806 17.4419L3.55806 12.6919C3.31398 12.4479 3.31398 12.0521 3.55806 11.8081L8.30806 7.05806C8.55214 6.81398 8.94786 6.81398 9.19194 7.05806Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Nn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "24/Cross", children: /* @__PURE__ */ a(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53267 7.63325C7.77675 7.38918 8.17247 7.38918 8.41655 7.63325L11.9746 11.1913L15.5327 7.63325C15.7767 7.38918 16.1725 7.38918 16.4166 7.63325C16.6606 7.87733 16.6606 8.27306 16.4166 8.51714L12.8585 12.0752L16.4166 15.6333C16.6606 15.8773 16.6606 16.2731 16.4166 16.5171C16.1725 16.7612 15.7767 16.7612 15.5327 16.5171L11.9746 12.9591L8.41655 16.5171C8.17247 16.7612 7.77675 16.7612 7.53267 16.5171C7.28859 16.2731 7.28859 15.8773 7.53267 15.6333L11.0907 12.0752L7.53267 8.51714C7.28859 8.27306 7.28859 7.87733 7.53267 7.63325Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Vn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a(
        "path",
        {
          d: "M16.0001 14.8223V21.8922M16.0001 10.1072V11.2856M26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function zn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a(
        "path",
        {
          d: "M12.8193 1.06163C14.2349 -0.353782 16.5297 -0.353738 17.9453 1.06163C19.2249 2.34124 19.3481 4.33929 18.3145 5.75695H20.625C22.0747 5.75695 23.2498 6.93233 23.25 8.38195V10.1319C23.25 10.6152 22.8582 11.0069 22.375 11.0069H22.25V20.3819C22.25 21.8317 21.0747 23.0069 19.625 23.0069H3.625C2.17525 23.0069 1 21.8317 1 20.3819V11.0069H0.875C0.39175 11.0069 0 10.6152 0 10.1319V8.38195C0.000156155 6.93233 1.17535 5.75695 2.625 5.75695H4.93652C3.90264 4.33928 4.02511 2.34133 5.30469 1.06163C6.72032 -0.353858 9.01603 -0.353898 10.4316 1.06163C10.8349 1.46506 11.1062 2.08711 11.2998 2.69152C11.4305 3.09959 11.5365 3.54123 11.625 3.97863C11.7135 3.54127 11.8195 3.09956 11.9502 2.69152C12.1439 2.08701 12.416 1.46505 12.8193 1.06163ZM2.25 20.3819C2.25 21.1413 2.86561 21.7569 3.625 21.7569H9V11.0069H2.25V20.3819ZM10.25 21.7569H13V7.00695H10.25V21.7569ZM14.25 21.7569H19.625C20.3844 21.7569 21 21.1413 21 20.3819V11.0069H14.25V21.7569ZM2.625 7.00695C1.8657 7.00695 1.25016 7.62269 1.25 8.38195V9.75695H9V7.00695H2.625ZM14.25 9.75695H22V8.38195C21.9998 7.62269 21.3843 7.00695 20.625 7.00695H14.25V9.75695ZM9.54688 1.94542C8.6194 1.01826 7.11589 1.01816 6.18848 1.94542C5.2612 2.87283 5.26131 4.37634 6.18848 5.30382C6.33551 5.45084 6.61121 5.6063 7.00879 5.75695H10.6416C10.6083 5.48036 10.5689 5.18025 10.5186 4.87218C10.4175 4.25402 10.2836 3.61639 10.1094 3.07238C9.92811 2.50663 9.72918 2.12775 9.54688 1.94542ZM17.0615 1.94542C16.1341 1.01821 14.6306 1.01816 13.7031 1.94542C13.5208 2.12776 13.3219 2.5067 13.1406 3.07238C12.9664 3.61637 12.8324 4.25406 12.7314 4.87218C12.6811 5.18025 12.6417 5.48036 12.6084 5.75695H16.2422C16.6393 5.60641 16.9146 5.45072 17.0615 5.30382C17.9888 4.37632 17.9889 2.87287 17.0615 1.94542Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Kn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "32/Pin", children: /* @__PURE__ */ a(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.3333 5.75C14.5873 5.75 12.9128 6.4436 11.6782 7.67821C10.4436 8.91283 9.75 10.5873 9.75 12.3333C9.75 15.7746 11.4823 19.288 13.2907 22.0006C14.1868 23.3448 15.084 24.4664 15.7569 25.2515C15.9758 25.5068 16.1705 25.7261 16.3333 25.9054C16.4962 25.7261 16.6909 25.5068 16.9097 25.2515C17.5827 24.4664 18.4799 23.3448 19.376 22.0006C21.1844 19.288 22.9167 15.7746 22.9167 12.3333C22.9167 10.5873 22.2231 8.91283 20.9885 7.67821C19.7538 6.4436 18.0793 5.75 16.3333 5.75ZM16.3333 27L16.8637 27.5303C16.5708 27.8232 16.0959 27.8232 15.803 27.5303L16.3333 27ZM10.6175 6.61755C12.1335 5.10163 14.1895 4.25 16.3333 4.25C18.4772 4.25 20.5332 5.10163 22.0491 6.61755C23.565 8.13347 24.4167 10.1895 24.4167 12.3333C24.4167 16.2254 22.4823 20.0453 20.624 22.8327C19.6868 24.2386 18.7506 25.4086 18.0486 26.2277C17.6973 26.6376 17.4037 26.9606 17.1967 27.1823C17.0932 27.2932 17.0113 27.3788 16.9546 27.4374C16.9263 27.4667 16.9042 27.4893 16.8889 27.5048L16.8711 27.5229L16.866 27.5279L16.8645 27.5295L16.864 27.53C16.8638 27.5302 16.8637 27.5303 16.3333 27C15.803 27.5303 15.8028 27.5302 15.8027 27.53L15.8022 27.5295L15.8006 27.5279L15.7956 27.5229L15.7777 27.5048C15.7624 27.4893 15.7404 27.4667 15.712 27.4374C15.6553 27.3788 15.5734 27.2932 15.4699 27.1823C15.263 26.9606 14.9694 26.6376 14.6181 26.2277C13.916 25.4086 12.9799 24.2386 12.0426 22.8327C10.1844 20.0453 8.25 16.2254 8.25 12.3333C8.25 10.1895 9.10163 8.13347 10.6175 6.61755ZM16.3333 9.41667C14.7225 9.41667 13.4167 10.7225 13.4167 12.3333C13.4167 13.9442 14.7225 15.25 16.3333 15.25C17.9442 15.25 19.25 13.9442 19.25 12.3333C19.25 10.7225 17.9442 9.41667 16.3333 9.41667ZM11.9167 12.3333C11.9167 9.89408 13.8941 7.91667 16.3333 7.91667C18.7726 7.91667 20.75 9.89408 20.75 12.3333C20.75 14.7726 18.7726 16.75 16.3333 16.75C13.8941 16.75 11.9167 14.7726 11.9167 12.3333Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Wn() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "32/User", children: /* @__PURE__ */ a(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.002 5.75C13.3786 5.75 11.252 7.87665 11.252 10.5C11.252 13.1233 13.3786 15.25 16.002 15.25C18.6253 15.25 20.752 13.1234 20.752 10.5C20.752 7.87665 18.6253 5.75 16.002 5.75ZM19.3082 15.8049C21.0759 14.7008 22.252 12.7377 22.252 10.5C22.252 7.04822 19.4537 4.25 16.002 4.25C12.5502 4.25 9.75195 7.04822 9.75195 10.5C9.75195 12.7377 10.9279 14.7008 12.6956 15.8048C9.06901 17.0662 6.45117 20.3445 6.45117 24.25V27C6.45117 27.4142 6.78696 27.75 7.20117 27.75C7.61539 27.75 7.95117 27.4142 7.95117 27V24.25C7.95117 20.1508 11.5077 16.75 16.002 16.75C20.496 16.75 24.0512 20.1506 24.0512 24.25V27C24.0512 27.4142 24.387 27.75 24.8012 27.75C25.2154 27.75 25.5512 27.4142 25.5512 27V24.25C25.5512 20.3447 22.9344 17.0663 19.3082 15.8049Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function $n() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "32/User Plus", children: /* @__PURE__ */ a(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.252 10.5C11.252 7.87665 13.3786 5.75 16.002 5.75C18.6253 5.75 20.752 7.87665 20.752 10.5C20.752 13.1234 18.6253 15.25 16.002 15.25C13.3786 15.25 11.252 13.1233 11.252 10.5ZM22.252 10.5C22.252 12.7372 21.0765 14.6998 19.3096 15.804C21.0133 16.3963 22.4913 17.434 23.5815 18.7727C23.8431 19.0939 23.7948 19.5663 23.4736 19.8278C23.1524 20.0894 22.68 20.0411 22.4185 19.7199C20.9543 17.9221 18.6323 16.75 16.002 16.75C11.5077 16.75 7.95117 20.1508 7.95117 24.25V27C7.95117 27.4142 7.61539 27.75 7.20117 27.75C6.78696 27.75 6.45117 27.4142 6.45117 27V24.25C6.45117 20.3445 9.06901 17.0662 12.6956 15.8048C10.9279 14.7008 9.75195 12.7377 9.75195 10.5C9.75195 7.04822 12.5502 4.25 16.002 4.25C19.4537 4.25 22.252 7.04822 22.252 10.5ZM24.05 22C24.05 21.5858 24.3858 21.25 24.8 21.25C25.2143 21.25 25.55 21.5858 25.55 22V23.75H27.3C27.7143 23.75 28.05 24.0858 28.05 24.5C28.05 24.9142 27.7143 25.25 27.3 25.25H25.55V27C25.55 27.4142 25.2143 27.75 24.8 27.75C24.3858 27.75 24.05 27.4142 24.05 27V25.25H22.3C21.8858 25.25 21.55 24.9142 21.55 24.5C21.55 24.0858 21.8858 23.75 22.3 23.75H24.05V22Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
const mt = ae(
  {}
);
function Gn({ children: t }) {
  const [e, r] = q(!1), [n, i] = q(), [s, o] = q(null), u = J(() => {
    function c(d, f = null) {
      i(d), r(!0), f && o(() => f);
    }
    function h() {
      r(!1), i(void 0), o(null);
    }
    return {
      isOpen: e,
      handleBack: s,
      handleClose: h,
      handleOpen: c,
      options: n
    };
  }, [e, s, n]);
  return /* @__PURE__ */ a(mt.Provider, { value: u, children: t });
}
function yt() {
  const t = tt(mt);
  if (!t)
    throw new Error(
      "useMobileDrawer must be used within a MobileDrawerProvider"
    );
  return t;
}
function Zn(t) {
  const e = ae(t), r = () => {
    const n = tt(e);
    if (n === void 0)
      throw new Error(
        "Context is attempting to be consumed outside of its provider."
      );
    return n;
  };
  return {
    Provider: e.Provider,
    useContext: r
  };
}
const Jn = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, Xn = () => {
  const t = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return Jn[t];
}, ge = () => {
  const t = Xn();
  return t ? `${window.location.origin}/${t}` : window.location.origin;
};
var G = { exports: {} };
G.exports;
var $e;
function Yn() {
  return $e || ($e = 1, function(t, e) {
    var r = 9007199254740991, n = "[object Arguments]", i = "[object Function]", s = "[object GeneratorFunction]", o = "[object Map]", u = "[object Object]", c = "[object Promise]", h = "[object Set]", d = "[object WeakMap]", f = "[object DataView]", b = /[\\^$.*+?()[\]{}|]/g, m = /^\[object .+?Constructor\]$/, R = typeof ee == "object" && ee && ee.Object === Object && ee, O = typeof self == "object" && self && self.Object === Object && self, p = R || O || Function("return this")(), w = e && !e.nodeType && e, M = w && !0 && t && !t.nodeType && t, g = M && M.exports === w;
    function C(l, x) {
      return l?.[x];
    }
    function _(l) {
      var x = !1;
      if (l != null && typeof l.toString != "function")
        try {
          x = !!(l + "");
        } catch {
        }
      return x;
    }
    function v(l, x) {
      return function(L) {
        return l(x(L));
      };
    }
    var S = Function.prototype, y = Object.prototype, E = p["__core-js_shared__"], F = function() {
      var l = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "");
      return l ? "Symbol(src)_1." + l : "";
    }(), Q = S.toString, Y = y.hasOwnProperty, z = y.toString, Wt = RegExp(
      "^" + Q.call(Y).replace(b, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), _e = g ? p.Buffer : void 0, Me = y.propertyIsEnumerable, $t = _e ? _e.isBuffer : void 0, Gt = v(Object.keys, Object), ce = W(p, "DataView"), de = W(p, "Map"), he = W(p, "Promise"), fe = W(p, "Set"), pe = W(p, "WeakMap"), Zt = !Me.call({ valueOf: 1 }, "valueOf"), Jt = H(ce), Xt = H(de), Yt = H(he), er = H(fe), tr = H(pe);
    function rr(l) {
      return z.call(l);
    }
    function nr(l) {
      if (!Te(l) || ir(l))
        return !1;
      var x = De(l) || _(l) ? Wt : m;
      return x.test(H(l));
    }
    function W(l, x) {
      var L = C(l, x);
      return nr(L) ? L : void 0;
    }
    var j = rr;
    (ce && j(new ce(new ArrayBuffer(1))) != f || de && j(new de()) != o || he && j(he.resolve()) != c || fe && j(new fe()) != h || pe && j(new pe()) != d) && (j = function(l) {
      var x = z.call(l), L = x == u ? l.constructor : void 0, Fe = L ? H(L) : void 0;
      if (Fe)
        switch (Fe) {
          case Jt:
            return f;
          case Xt:
            return o;
          case Yt:
            return c;
          case er:
            return h;
          case tr:
            return d;
        }
      return x;
    });
    function ir(l) {
      return !!F && F in l;
    }
    function sr(l) {
      var x = l && l.constructor, L = typeof x == "function" && x.prototype || y;
      return l === L;
    }
    function H(l) {
      if (l != null) {
        try {
          return Q.call(l);
        } catch {
        }
        try {
          return l + "";
        } catch {
        }
      }
      return "";
    }
    function or(l) {
      return ur(l) && Y.call(l, "callee") && (!Me.call(l, "callee") || z.call(l) == n);
    }
    var ar = Array.isArray;
    function Ie(l) {
      return l != null && dr(l.length) && !De(l);
    }
    function ur(l) {
      return hr(l) && Ie(l);
    }
    var lr = $t || fr;
    function cr(l) {
      if (Ie(l) && (ar(l) || typeof l == "string" || typeof l.splice == "function" || lr(l) || or(l)))
        return !l.length;
      var x = j(l);
      if (x == o || x == h)
        return !l.size;
      if (Zt || sr(l))
        return !Gt(l).length;
      for (var L in l)
        if (Y.call(l, L))
          return !1;
      return !0;
    }
    function De(l) {
      var x = Te(l) ? z.call(l) : "";
      return x == i || x == s;
    }
    function dr(l) {
      return typeof l == "number" && l > -1 && l % 1 == 0 && l <= r;
    }
    function Te(l) {
      var x = typeof l;
      return !!l && (x == "object" || x == "function");
    }
    function hr(l) {
      return !!l && typeof l == "object";
    }
    function fr() {
      return !1;
    }
    t.exports = cr;
  }(G, G.exports)), G.exports;
}
var ei = Yn();
const ti = /* @__PURE__ */ Xr(ei);
function Ge(t) {
  return ti(t);
}
const ri = (t, e) => window.localStorage.setItem(t, e), ni = (t) => window.localStorage.getItem(t), ii = (t) => window.localStorage.removeItem(t), si = {
  setItem: ri,
  getItem: ni,
  removeItem: ii
}, oi = ({
  title: t,
  onClose: e,
  handleBack: r
}) => /* @__PURE__ */ D("div", { className: "flex flex-row justify-between p-4", children: [
  /* @__PURE__ */ D("div", { className: "flex flex-row gap-2 items-center", children: [
    r && /* @__PURE__ */ a(ie, { onClick: r, color: "secondary", children: /* @__PURE__ */ a(Hn, {}) }),
    /* @__PURE__ */ a(U, { variant: "h2", children: t })
  ] }),
  /* @__PURE__ */ a(ie, { onClick: e, color: "secondary", children: /* @__PURE__ */ a(Nn, {}) })
] });
function ai({ children: t, ...e }) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: "flex flex-row gap-2 justify-end p-4 pt-3 border-t",
      ...e,
      children: t
    }
  );
}
function ui({
  isOpen: t,
  handleClose: e,
  handleBack: r,
  content: n,
  actions: i,
  title: s
}) {
  return /* @__PURE__ */ D(
    Cr,
    {
      open: t,
      onClose: e,
      anchor: "bottom",
      PaperProps: {
        className: "rounded-t-[20px] flex flex-col gap-2"
      },
      children: [
        typeof s == "string" ? /* @__PURE__ */ a(
          oi,
          {
            title: s,
            onClose: e,
            handleBack: r
          }
        ) : s,
        /* @__PURE__ */ a("div", { className: "px-4 pb-4", children: n }),
        i && /* @__PURE__ */ a(ai, { children: i })
      ]
    }
  );
}
const li = ae(null), ve = {
  didCatch: !1,
  error: null
};
let ci = class extends pr {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = ve;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var r, n, i = arguments.length, s = new Array(i), o = 0; o < i; o++)
        s[o] = arguments[o];
      (r = (n = this.props).onReset) === null || r === void 0 || r.call(n, {
        args: s,
        reason: "imperative-api"
      }), this.setState(ve);
    }
  }
  componentDidCatch(e, r) {
    var n, i;
    (n = (i = this.props).onError) === null || n === void 0 || n.call(i, e, r);
  }
  componentDidUpdate(e, r) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (n && r.error !== null && di(e.resetKeys, i)) {
      var s, o;
      (s = (o = this.props).onReset) === null || s === void 0 || s.call(o, {
        next: i,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(ve);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: r,
      FallbackComponent: n,
      fallback: i
    } = this.props, {
      didCatch: s,
      error: o
    } = this.state;
    let u = e;
    if (s) {
      const c = {
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        u = r(c);
      else if (n)
        u = Le(n, c);
      else if (i !== void 0)
        u = i;
      else
        throw o;
    }
    return Le(li.Provider, {
      value: {
        didCatch: s,
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
};
function di() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
function hi({ fallbackMessage: t }) {
  return /* @__PURE__ */ a("div", { className: "flex flex-col gap-4 justify-center items-center p-4", children: t });
}
function fi({
  children: t,
  fallbackMessage: e
}) {
  return /* @__PURE__ */ a(
    ci,
    {
      FallbackComponent: (r) => /* @__PURE__ */ a(hi, { ...r, fallbackMessage: e }),
      children: t
    }
  );
}
function pi() {
  const { isOpen: t, options: e, handleBack: r, handleClose: n } = yt(), {
    title: i,
    content: s,
    actions: o,
    cancelLabel: u,
    confirmLabel: c,
    onCancel: h,
    onConfirm: d
  } = e || {};
  return /* @__PURE__ */ a(
    ui,
    {
      actions: o,
      cancelLabel: u,
      confirmLabel: c,
      content: s,
      handleBack: r,
      isOpen: t,
      onCancel: h,
      onConfirm: d,
      title: i,
      handleClose: n
    }
  );
}
const mi = 5e3, yi = {
  isOpen: !1,
  content: "",
  severity: "success"
}, gi = ae({});
function vi({ children: t }) {
  const [e, r] = q(yi), { isOpen: n, content: i, severity: s } = e;
  function o(h) {
    r({
      isOpen: !0,
      ...h
    });
  }
  function u() {
    r((h) => ({
      ...h,
      content: "",
      isOpen: !1
    }));
  }
  const c = J(() => ({
    open: o,
    close: u
  }), []);
  return /* @__PURE__ */ D(gi.Provider, { value: c, children: [
    t,
    /* @__PURE__ */ a(
      Sr,
      {
        open: n,
        anchorOrigin: bi,
        autoHideDuration: mi,
        sx: Si,
        onClose: u,
        children: /* @__PURE__ */ a(
          Or,
          {
            severity: s,
            variant: "filled",
            sx: Ci,
            icon: !1,
            onClose: u,
            children: i
          }
        )
      }
    )
  ] });
}
const bi = {
  vertical: "bottom",
  horizontal: "center"
}, Ci = {
  width: "100%",
  borderRadius: "24px",
  color: "white"
}, Si = {
  zIndex: 999999942
}, Oi = ["en", "it", "de", "es", "fr"], Ri = "en", wi = {
  order: ["path"],
  lookupFromPathIndex: 0
}, Ei = {
  fallbackLng: Ri,
  detection: wi,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  supportedLngs: Oi,
  keySeparator: "::",
  nsSeparator: ":::",
  returnEmptyString: !1
};
function Pi({
  resourcesToBackendCallback: t,
  ...e
}) {
  const r = {
    backend: {
      backends: [Fr(t)]
    }
  }, n = Ir({
    ...Ei,
    ...e,
    ...r
  });
  return n.use(Dr).use(Tr), n;
}
function xe(t, e) {
  return `${t.charAt(0)}${e.charAt(0)}`.toUpperCase();
}
function xi() {
  return /* @__PURE__ */ a(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ a("g", { id: "32/Box Arrow", children: /* @__PURE__ */ D("g", { id: "Vector", children: [
        /* @__PURE__ */ a(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.78186 4.9607C6.888 4.66138 7.17115 4.46136 7.48873 4.46136H24.7489C25.0665 4.46136 25.3496 4.66138 25.4558 4.9607L27.7067 11.3083C27.7881 11.5379 27.7529 11.7928 27.6124 11.9917C27.4718 12.1907 27.2434 12.309 26.9998 12.309H5.2378C4.9942 12.309 4.76577 12.1907 4.62522 11.9917C4.48467 11.7928 4.44951 11.5379 4.53093 11.3083L6.78186 4.9607ZM8.01853 5.96136L6.29951 10.809H25.9381L24.2191 5.96136H8.01853Z",
            fill: "#4D4E58"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.1189 4.46136C16.5331 4.46136 16.8689 4.79715 16.8689 5.21136V11.559C16.8689 11.9732 16.5331 12.309 16.1189 12.309C15.7047 12.309 15.3689 11.9732 15.3689 11.559V5.21136C15.3689 4.79715 15.7047 4.46136 16.1189 4.46136Z",
            fill: "#4D4E58"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.2378 10.8091C4.82358 10.8091 4.4878 11.1449 4.4878 11.5591V15.3485C4.4878 15.7628 4.82358 16.0985 5.2378 16.0985C5.65201 16.0985 5.9878 15.7628 5.9878 15.3485V12.3091H26.2498V25.9646H5.9878V19.8857H14.7018L13.3091 21.2796C13.0164 21.5726 13.0166 22.0474 13.3096 22.3402C13.6026 22.633 14.0775 22.6328 14.3702 22.3398L17.0421 19.6657C17.3347 19.3728 17.3347 18.8983 17.0421 18.6054L14.3702 15.9313C14.0775 15.6383 13.6026 15.6381 13.3096 15.9309C13.0166 16.2237 13.0164 16.6985 13.3091 16.9916L14.7021 18.3857H5.2378C4.82358 18.3857 4.4878 18.7215 4.4878 19.1357V26.7146C4.4878 27.1288 4.82358 27.4646 5.2378 27.4646H26.9998C27.414 27.4646 27.7498 27.1288 27.7498 26.7146V11.5591C27.7498 11.1449 27.414 10.8091 26.9998 10.8091H5.2378Z",
            fill: "#4D4E58"
          }
        )
      ] }) })
    }
  );
}
const _i = {
  appDataStorageKey: "mage-cache-storage"
};
ENVIRONMENT_REGION;
const Ze = "private-content-loaded", Mi = "customer-menu", { appDataStorageKey: Ii } = _i;
function Je() {
  return JSON.parse(si.getItem(Ii) || "{}")?.customer || {};
}
function Di() {
  window.dispatchEvent(new CustomEvent(Mi));
}
var A = /* @__PURE__ */ ((t) => (t[t.TIER_1_GROUP_ID = 1] = "TIER_1_GROUP_ID", t[t.TIER_2_GROUP_ID = 2] = "TIER_2_GROUP_ID", t[t.TIER_3_GROUP_ID = 3] = "TIER_3_GROUP_ID", t[t.TIER_5_GROUP_ID = 5] = "TIER_5_GROUP_ID", t[t.TIER_8_GROUP_ID = 8] = "TIER_8_GROUP_ID", t[t.TIER_10_GROUP_ID = 10] = "TIER_10_GROUP_ID", t[t.TIER_0_GROUP_ID = 11] = "TIER_0_GROUP_ID", t[t.TIER_7_GROUP_ID = 12] = "TIER_7_GROUP_ID", t[t.TIER_13_GROUP_ID = 13] = "TIER_13_GROUP_ID", t[t.TIER_99_GROUP_ID = 14] = "TIER_99_GROUP_ID", t[t.TIER_9_GROUP_ID = 15] = "TIER_9_GROUP_ID", t[t.TIER_15_GROUP_ID = 16] = "TIER_15_GROUP_ID", t[t.TIER_16_GROUP_ID = 17] = "TIER_16_GROUP_ID", t[t.TIER_MCX_GROUP_ID = 21] = "TIER_MCX_GROUP_ID", t[t.TIER_400_GROUP_ID = 22] = "TIER_400_GROUP_ID", t))(A || {});
const Ti = {
  digitalCatalogDownloadsFeatureFlag: "DIS-125-digitalcatalogdownloads",
  loyaltyFeatureFlag: "IML-137-loyalty-program"
}, Fi = (t, e) => {
  const [r, n] = q(null), [i, s] = q(!0), o = rt(() => {
    let u = 0;
    const c = window?.mb, h = setInterval(() => {
      c && c.abtConfig?.areFlagsFetched === !0 ? (n(
        c.abtConfig?.visitor?.getFlag(t)?.getValue(e)
      ), clearInterval(h), s(!1)) : u >= 20 && (clearInterval(h), s(!1)), u++;
    }, 100);
  }, [e, t]);
  return nt(() => {
    const u = window?.mb;
    if (u && u.abtConfig?.areFlagsFetched === !0) {
      n(
        u.abtConfig?.visitor?.getFlag(t)?.getValue(e)
      ), s(!1);
      return;
    }
    o();
  }, [o, t, e]), { flagValue: r, isLoading: i };
};
function Li() {
  const { flagValue: t, isLoading: e } = Fi(
    Ti.loyaltyFeatureFlag,
    !1
  );
  return {
    isLoading: e,
    flagValue: t
  };
}
const ki = yr.create({
  withCredentials: !0,
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
}), Ui = () => Cn({
  queryKey: ["getLoyaltyConfiguration"],
  queryFn: () => ki.get("/rest/V1/m-select/configuration").then((t) => t.data.data)
}), Ai = () => {
  const { data: t } = Ui(), { flagValue: e, isLoading: r } = Li(), n = J(() => t?.is_loyalty_program_enabled && t?.is_customer_eligible, [t]);
  return {
    flagState: { flagValue: e, isLoading: r },
    loyaltyProgramEnabled: n && e
  };
};
function N({
  title: t,
  label: e,
  icon: r,
  href: n,
  target: i,
  onClick: s
}) {
  return /* @__PURE__ */ D(
    Rr,
    {
      href: n,
      target: i,
      component: "a",
      className: "gap-3 p-2 px-4",
      onClick: s,
      children: [
        /* @__PURE__ */ a(wr, { className: "flex justify-center", color: "text.primary", children: /* @__PURE__ */ a(U, { color: "text.primary", children: r }) }),
        /* @__PURE__ */ D("span", { className: "flex flex-col truncate", children: [
          /* @__PURE__ */ a(U, { variant: "caption", noWrap: !0, children: t }),
          e ? /* @__PURE__ */ a(
            U,
            {
              variant: "caption",
              className: "text-[12px] leading-[20px] text-[#707075]",
              noWrap: !0,
              children: e
            }
          ) : null
        ] })
      ]
    }
  );
}
function qi({
  avatar: t,
  firstName: e,
  lastName: r,
  company: n,
  membership: i
}) {
  const s = xe(e, r), o = `${e} ${r}`;
  return /* @__PURE__ */ D("div", { className: "flex flex-row gap-4 p-4", children: [
    /* @__PURE__ */ a(pt, { src: t, alt: o, className: "w-16 h-16 bg-blue-100", children: /* @__PURE__ */ a(
      U,
      {
        variant: "title1",
        fontSize: "24px",
        lineHeight: "32px",
        title: n,
        noWrap: !0,
        children: s
      }
    ) }),
    /* @__PURE__ */ D("div", { className: "flex flex-col gap-1 text-left truncate", children: [
      /* @__PURE__ */ a(
        U,
        {
          variant: "body1",
          color: "primary.main",
          fontWeight: "600",
          noWrap: !0,
          title: o,
          children: o
        }
      ),
      /* @__PURE__ */ D("div", { className: "flex flex-col text-left truncate", children: [
        /* @__PURE__ */ a(U, { variant: "caption", color: "#707075", title: n, noWrap: !0, children: n }),
        /* @__PURE__ */ a(
          U,
          {
            variant: "caption",
            color: "#707075",
            title: i,
            noWrap: !0,
            children: i
          }
        )
      ] })
    ] })
  ] });
}
const Qi = "https://materialbank.referralrock.com/v2/1/access?_ga=2.91218072.388031893.1732542725-1718535315.1721316195", Bi = "/orders", ji = "/returns", Hi = "/customer/account/logout", Ni = "address-modal", re = 13;
function Vi() {
  const [t, e] = q(!0), [r, n] = q(
    () => {
      const i = Je();
      return Ge(i) ? null : (e(!1), i);
    }
  );
  return nt(() => {
    const i = Je();
    Ge(i) || (n(i), e(!1));
    function s(o) {
      n(o.detail.data.customer), e(!1);
    }
    return window.addEventListener(Ze, s), () => {
      window.removeEventListener(
        Ze,
        s
      );
    };
  }, []), {
    isLoading: t,
    customer: r
  };
}
const { Provider: zi, useContext: Ki } = Zn();
function Wi({ children: t }) {
  const { isLoading: e, customer: r } = Vi(), n = J(() => ({
    isLoading: e,
    customer: r
  }), [e, r]);
  return /* @__PURE__ */ a(zi, { value: n, children: t });
}
function gt() {
  const { t } = Re(), { customer: e, isLoading: r } = Ki(), n = J(() => {
    function i(o) {
      if (!o)
        return "";
      switch (o) {
        case A.TIER_1_GROUP_ID:
        case A.TIER_2_GROUP_ID:
        case A.TIER_10_GROUP_ID:
          return t("Professional Member");
        case A.TIER_3_GROUP_ID:
        case A.TIER_7_GROUP_ID:
          return t("Digital Member");
        case A.TIER_9_GROUP_ID:
          return t("Education member");
        case A.TIER_99_GROUP_ID:
          return t("Student");
        case A.TIER_13_GROUP_ID:
          return t("Rep");
        default:
          return "";
      }
    }
    const s = e?.hasAssociatedBrands && e?.brandResourcesAccess || !1;
    return {
      firstName: e?.firstname ?? "",
      lastName: e?.lastname ?? "",
      email: e?.email ?? "",
      address: e?.defaultAddress?.address ?? "",
      company: e?.company_name ?? "",
      membership: i(e?.groupId) ?? "",
      avatar: e?.profileImage ?? "",
      selectedAddressId: e?.defaultAddress?.id ?? "",
      showBrandRepSection: s,
      mSelectPoints: e?.loyalty_points ?? 0
    };
  }, [
    e?.brandResourcesAccess,
    e?.company_name,
    e?.defaultAddress?.address,
    e?.defaultAddress?.id,
    e?.email,
    e?.firstname,
    e?.groupId,
    e?.hasAssociatedBrands,
    e?.lastname,
    e?.profileImage,
    e?.loyalty_points,
    t
  ]);
  return {
    isLoading: r,
    user: n
  };
}
function $i(t) {
  return new Intl.NumberFormat("en-US").format(Number(t));
}
function vt({
  user: {
    firstName: t,
    lastName: e,
    email: r,
    address: n,
    mSelectPoints: i,
    avatar: s,
    company: o,
    membership: u,
    selectedAddressId: c
  },
  onClose: h
}) {
  const { t: d } = Re(), { user: f } = gt(), { loyaltyProgramEnabled: b } = Ai();
  function m() {
    h?.();
    const g = `${ge()}/customer/account`;
    window.location.href = g;
  }
  const R = rt(() => {
    h?.();
    const g = `${ge()}/m-select`;
    window.location.href = g;
  }, [h]);
  function O() {
    h?.(), Di();
  }
  function p() {
    h?.(), window.dispatchEvent(
      new CustomEvent(Ni, {
        detail: {
          selectedAddressId: c,
          multiAddress: !1,
          fromCustomerMenu: !0
        }
      })
    );
  }
  const w = ge();
  return /* @__PURE__ */ D(Ye, { children: [
    /* @__PURE__ */ a(
      qi,
      {
        avatar: s,
        firstName: t,
        lastName: e,
        company: o,
        membership: u
      }
    ),
    f.showBrandRepSection && /* @__PURE__ */ a(
      N,
      {
        title: d("Brand settings"),
        icon: /* @__PURE__ */ a(Vn, {}),
        onClick: O
      }
    ),
    /* @__PURE__ */ a(
      N,
      {
        title: d("Orders"),
        icon: /* @__PURE__ */ a(xi, {}),
        href: `${w}${Bi}`
      }
    ),
    /* @__PURE__ */ a(
      N,
      {
        title: d("Profile"),
        label: r,
        icon: /* @__PURE__ */ a(Wn, {}),
        onClick: m
      }
    ),
    /* @__PURE__ */ a(
      N,
      {
        title: d("Address Book"),
        label: n,
        icon: /* @__PURE__ */ a(Kn, {}),
        onClick: p
      }
    ),
    !!b && /* @__PURE__ */ a(
      N,
      {
        title: d("Material Select"),
        label: `${$i(i)} ${d("Points").toLowerCase()}`,
        icon: /* @__PURE__ */ a(zn, {}),
        onClick: R
      }
    ),
    /* @__PURE__ */ a(
      N,
      {
        title: d("Refer a friend"),
        label: d("Earn rewards with each referral"),
        icon: /* @__PURE__ */ a($n, {}),
        href: Qi,
        target: "_blank"
      }
    ),
    /* @__PURE__ */ a(
      N,
      {
        title: d("Sample returns"),
        label: d("Return your unneeded samples for reuse"),
        icon: /* @__PURE__ */ a(jn, {}),
        href: `${w}${ji}`
      }
    ),
    /* @__PURE__ */ a(Er, {}),
    /* @__PURE__ */ a("div", { className: "flex flex-col px-4 mt-4 pb-2", children: /* @__PURE__ */ a(Pr, { component: "a", href: `${w}${Hi}`, children: d("Sign out") }) })
  ] });
}
function bt({
  avatar: t,
  initials: e
}) {
  return /* @__PURE__ */ a(pt, { src: t, alt: e, className: "w-8 h-8 bg-blue-100", children: /* @__PURE__ */ a(
    U,
    {
      variant: "title1",
      fontSize: "12px",
      lineHeight: "18px",
      title: e,
      noWrap: !0,
      children: e
    }
  ) });
}
function Gi({
  user: t,
  isLoading: e = !1
}) {
  const { t: r } = Re(), { handleOpen: n, handleClose: i } = yt(), { firstName: s, lastName: o, avatar: u } = t, c = xe(s, o);
  function h() {
    n({
      title: r("User profile"),
      content: /* @__PURE__ */ a(vt, { user: t, onClose: i })
    });
  }
  return /* @__PURE__ */ a(
    ie,
    {
      size: "small",
      "aria-haspopup": "true",
      disabled: e,
      onClick: h,
      children: /* @__PURE__ */ a(bt, { initials: c, avatar: u })
    }
  );
}
function Zi({
  isOpen: t,
  anchorEl: e,
  onClose: r,
  ...n
}) {
  return /* @__PURE__ */ a(
    xr,
    {
      id: "user-profile-menu",
      anchorEl: e,
      open: t,
      transformOrigin: Xi,
      anchorOrigin: Ji,
      PaperProps: Yi,
      onClose: r,
      onClick: r,
      children: /* @__PURE__ */ a(vt, { ...n })
    }
  );
}
const Ji = {
  horizontal: "right",
  vertical: "bottom"
}, Xi = {
  horizontal: "right",
  vertical: "top"
}, Yi = {
  sx: {
    width: "336px",
    borderRadius: "12px"
  }
};
function es({
  user: { firstName: t, lastName: e, avatar: r, company: n },
  isOpen: i,
  isLoading: s = !1,
  onOpen: o
}) {
  const u = xe(t, e), c = `${t} ${e}`, h = c.length > re ? `${c.slice(0, re)}...` : c, d = n.length > re ? `${n.slice(0, re)}...` : n;
  return /* @__PURE__ */ a(
    ie,
    {
      size: "small",
      "aria-haspopup": "true",
      "aria-controls": i ? "user-menu" : void 0,
      "aria-expanded": i ? "true" : void 0,
      disabled: s,
      onClick: o,
      children: /* @__PURE__ */ D("div", { className: "flex flex-row gap-3 items-center h-12 px-2 pr-4 border border-[#F2F2F2] rounded-full hover:bg-[#F5F5F7] hover:border-[#F5F5F7]", children: [
        /* @__PURE__ */ a(bt, { initials: u, avatar: r }),
        /* @__PURE__ */ D("div", { className: "flex flex-col text-left truncate", children: [
          /* @__PURE__ */ a(
            U,
            {
              variant: "caption",
              color: "primary.main",
              noWrap: !0,
              title: h,
              children: h
            }
          ),
          /* @__PURE__ */ a(
            U,
            {
              variant: "caption3",
              color: "#707075",
              fontWeight: "600",
              title: n,
              noWrap: !0,
              children: d.toUpperCase()
            }
          )
        ] })
      ] })
    }
  );
}
function ts({
  user: t,
  isLoading: e = !1
}) {
  const { anchorEl: r, open: n, onOpen: i, onClose: s } = Bn();
  return /* @__PURE__ */ D(Ye, { children: [
    /* @__PURE__ */ a(
      es,
      {
        isOpen: n,
        isLoading: e,
        user: t,
        onOpen: i
      }
    ),
    /* @__PURE__ */ a(
      Zi,
      {
        isOpen: n,
        anchorEl: r,
        user: t,
        onClose: s
      }
    )
  ] });
}
function rs() {
  const { isMobile: t } = qn(), { isLoading: e, user: r } = gt();
  return t ? /* @__PURE__ */ a(Gi, { isLoading: e, user: r }) : /* @__PURE__ */ a(ts, { isLoading: e, user: r });
}
function ns() {
  return /* @__PURE__ */ a(rs, {});
}
const Xe = "navigation-top-bar";
function is() {
  return Pi({
    resourcesToBackendCallback: cs,
    ns: [Xe],
    defaultNS: Xe
  });
}
const Ct = is();
Ct.init();
const ss = {
  en: St,
  fr: as,
  it: os,
  es: ls,
  de: us
};
function os() {
  return Promise.resolve().then(() => ps);
}
function as() {
  return Promise.resolve().then(() => ys);
}
function us() {
  return Promise.resolve().then(() => vs);
}
function St() {
  return Promise.resolve().then(() => Cs);
}
function ls() {
  return Promise.resolve().then(() => Os);
}
function cs(t) {
  return ss[t]() ?? St();
}
const ds = "Something went wrong. Please try again later.", hs = new Gr();
function ks() {
  return /* @__PURE__ */ a(mr, { children: /* @__PURE__ */ a(An, { children: /* @__PURE__ */ a(fi, { fallbackMessage: ds, children: /* @__PURE__ */ a(Mr, { i18n: Ct, children: /* @__PURE__ */ a(vi, { children: /* @__PURE__ */ a(Gn, { children: /* @__PURE__ */ a(Wi, { children: /* @__PURE__ */ D(on, { client: hs, children: [
    /* @__PURE__ */ a(ns, {}),
    /* @__PURE__ */ a(pi, {})
  ] }) }) }) }) }) }) }) });
}
const Ot = "Ordini", Rt = "Profilo", wt = "Rappresentante", Et = "Studente", Pt = "Punti", fs = {
  "Address Book": "Rubrica",
  "Brand settings": "Impostazioni del marchio",
  "Digital Member": "Membro digitale",
  "Earn rewards with each referral": "Ottieni un regalo per ogni referral",
  "Education member": "Membro educazione",
  "Material Select": "Selezione del materiale",
  Orders: Ot,
  "Professional Member": "Membro professionale",
  Profile: Rt,
  "Refer a friend": "Invita un amico",
  Rep: wt,
  "Return your unneeded samples for reuse": "Restituisci i campioni inutilizzati per il riutilizzo",
  "Sample returns": "Restituzione campioni",
  "Sign out": "Esci",
  Student: Et,
  "User profile": "Profilo utente",
  Points: Pt
}, ps = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: Ot,
  Points: Pt,
  Profile: Rt,
  Rep: wt,
  Student: Et,
  default: fs
}, Symbol.toStringTag, { value: "Module" })), xt = "Commandes", _t = "Profil", Mt = "Représentant", It = "Étudiant", Dt = "Points", ms = {
  "Address Book": "Carnet d'adresses",
  "Brand settings": "Paramètres de la marque",
  "Digital Member": "Membre numérique",
  "Earn rewards with each referral": "Gagnez des récompenses pour chaque parrainage",
  "Education member": "Membre éducation",
  "Material Select": "Sélection du matériau",
  Orders: xt,
  "Professional Member": "Membre professionnel",
  Profile: _t,
  "Refer a friend": "Parrainez un ami",
  Rep: Mt,
  "Return your unneeded samples for reuse": "Retournez vos échantillons inutiles pour réutilisation",
  "Sample returns": "Retours d'échantillons",
  "Sign out": "Se déconnecter",
  Student: It,
  "User profile": "Profil utilisateur",
  Points: Dt
}, ys = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: xt,
  Points: Dt,
  Profile: _t,
  Rep: Mt,
  Student: It,
  default: ms
}, Symbol.toStringTag, { value: "Module" })), Tt = "Bestellungen", Ft = "Profil", Lt = "Vertreter", kt = "Student", Ut = "Punkte", gs = {
  "Address Book": "Adressbuch",
  "Brand settings": "Markeneinstellungen",
  "Digital Member": "Digitales Member",
  "Earn rewards with each referral": "Erhalte Prämien mit jeder Empfehlung",
  "Education member": "Bildungs Member",
  "Material Select": "Material auswählen",
  Orders: Tt,
  "Professional Member": "Professionelles Member",
  Profile: Ft,
  "Refer a friend": "Freunden empfehlen",
  Rep: Lt,
  "Return your unneeded samples for reuse": "Schicke deine übrigen Muster zur Weiterverwendung zurück",
  "Sample returns": "Muster-Rücksendung",
  "Sign out": "Abmelden",
  Student: kt,
  "User profile": "Benutzerprofil",
  Points: Ut
}, vs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: Tt,
  Points: Ut,
  Profile: Ft,
  Rep: Lt,
  Student: kt,
  default: gs
}, Symbol.toStringTag, { value: "Module" })), At = "", qt = "", Qt = "", Bt = "", jt = "", bs = {
  "Address Book": "",
  "Brand settings": "",
  "Digital Member": "",
  "Earn rewards with each referral": "",
  "Education member": "",
  "Material Select": "",
  Orders: At,
  "Professional Member": "",
  Profile: qt,
  "Refer a friend": "",
  Rep: Qt,
  "Return your unneeded samples for reuse": "",
  "Sample returns": "",
  "Sign out": "",
  Student: Bt,
  "User profile": "",
  Points: jt
}, Cs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: At,
  Points: jt,
  Profile: qt,
  Rep: Qt,
  Student: Bt,
  default: bs
}, Symbol.toStringTag, { value: "Module" })), Ht = "Pedidos", Nt = "Perfil", Vt = "Representante", zt = "Estudiante", Kt = "Puntos", Ss = {
  "Address Book": "Libro de direcciones",
  "Brand settings": "Configuración de la marca",
  "Digital Member": "Miembro digital",
  "Earn rewards with each referral": "Gana recompensas con cada recomendación",
  "Education member": "Miembro educación",
  "Material Select": "Selección de material",
  Orders: Ht,
  "Professional Member": "Miembro profesional",
  Profile: Nt,
  "Refer a friend": "Invita a un amigo",
  Rep: Vt,
  "Return your unneeded samples for reuse": "Devuelve tus muestras no necesarias para su reutilización",
  "Sample returns": "Devolución de muestras",
  "Sign out": "Cerrar sesión",
  Student: zt,
  "User profile": "Perfil de usuario",
  Points: Kt
}, Os = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: Ht,
  Points: Kt,
  Profile: Nt,
  Rep: Vt,
  Student: zt,
  default: Ss
}, Symbol.toStringTag, { value: "Module" }));
export {
  ks as NavigationTopBarApp
};
